/**
 * 2026-10 — 「加官方 LINE」按鈕。
 *
 * 用在:中國「微信支付開通中,請先私訊官方 LINE」提醒、香港 FPS 感謝面板
 * (「轉帳後請截圖傳至官方 LINE」)。連結由 lib/overseasCheckout.js 的
 * lineAddFriendUrl() 算好;href 空字串就整顆不顯示,不放一顆點了會壞的鈕。
 * 沒有 hook,server / client component 都能直接用。
 */
export default function LineAddFriendButton({ href, label = "加官方 LINE" }) {
  if (!href) return null;
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="line-add-friend"
      className="transition-opacity hover:opacity-85 active:opacity-75"
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: "8px",
        width: "100%",
        minHeight: "44px",
        marginTop: "10px",
        padding: "10px 16px",
        borderRadius: "var(--radius-full, 999px)",
        // LINE 品牌綠底白字:8 組主題(亮/暗)上都看得清楚
        backgroundColor: "#06C755",
        color: "#fff",
        fontSize: "15px",
        fontWeight: 700,
        textDecoration: "none",
      }}
    >
      <svg
        width="20"
        height="20"
        viewBox="0 0 24 24"
        fill="currentColor"
        aria-hidden="true"
      >
        <path d="M12 3C6.48 3 2 6.6 2 11.04c0 3.98 3.53 7.31 8.3 7.94.32.07.76.21.87.49.1.25.07.64.03.9l-.14.85c-.04.25-.2.98.86.53 1.06-.45 5.7-3.36 7.78-5.75C21.14 14.43 22 12.84 22 11.04 22 6.6 17.52 3 12 3Zm-3.85 10.6H6.17a.53.53 0 0 1-.53-.53V9.1a.53.53 0 1 1 1.06 0v3.44h1.45a.53.53 0 1 1 0 1.06Zm2.05-.53a.53.53 0 1 1-1.06 0V9.1a.53.53 0 1 1 1.06 0v3.97Zm4.77 0a.53.53 0 0 1-.95.32l-2.03-2.76v2.44a.53.53 0 1 1-1.06 0V9.1a.53.53 0 0 1 .95-.32l2.03 2.76V9.1a.53.53 0 1 1 1.06 0v3.97Zm3.2-2.51a.53.53 0 1 1 0 1.06h-1.45v.92h1.45a.53.53 0 1 1 0 1.06h-1.98a.53.53 0 0 1-.53-.53V9.1c0-.29.24-.53.53-.53h1.98a.53.53 0 1 1 0 1.06h-1.45v.93h1.45Z" />
      </svg>
      {label}
    </a>
  );
}
